/**
 * Size spec for the hamburger + Joy logo cluster that opens a navigation drawer. The admin shell
 * header is the reference — product direction is that every surface carrying this cluster matches
 * it rather than carrying its own numbers — and it lives in `@shared` because Service Center
 * renders the same cluster outside `@apps/admin`, which card may not import from.
 *
 * `@apps/admin/components/AdminShell/AdminShell.constants` re-exports both of these under the same
 * names, so admin keeps reading the whole shell spec from one file. Change a value here and every
 * shell surface follows; don't re-declare these numbers locally.
 */

/** Gap between the hamburger + logo cluster and the title, and between the hamburger and the
 *  logo inside the cluster, as a theme space-scale index (3 = 8px). */
export const ADMIN_SHELL_BRAND_GAP = 3;

/** Hamburger + Joy logo sizing passed to `BurgerLogoTrigger`. The logo is the brand's XS cut,
 *  whose rounder details hold up at this size; it fills its 27×17 box exactly, so the width is
 *  height × 27/17. The 1.5px nudge optically centres it against the 24px hamburger. */
export const ADMIN_SHELL_BURGER_LOGO = {
  hamburgerSize: 24,
  logoMark: 'xs',
  logoWidth: 34.94,
  logoHeight: 22,
  logoTranslateY: 1.5,
} as const;
